export const positiveBar = (bar, radius) => {
    return `M${bar.x} ${bar.y + radius} 
        L${bar.x}, ${bar.y + bar.height}
        L${bar.x + bar.width}, ${bar.y + bar.height}
        L${bar.x + bar.width}, ${bar.y + radius}
        Q${bar.x + bar.width}, ${bar.y} ${bar.x + bar.width - radius}, ${bar.y }
        L${bar.x + radius} ${bar.y}
        Q${bar.x}, ${bar.y} ${bar.x}, ${bar.y + radius}`
}

export const negativeBar = (bar, radius) => {
    return `M${bar.x} ${bar.y} 
        L${bar.x}, ${bar.y + bar.height - radius}
        Q${bar.x}, ${bar.y + bar.height} ${bar.x + radius}, ${bar.y + bar.height}
        L${bar.x + bar.width - radius}, ${bar.y + bar.height}
        Q${bar.x + bar.width}, ${bar.y + bar.height} ${bar.x + bar.width}, ${bar.y + bar.height - radius}
        L${bar.x + bar.width}, ${bar.y}
        L${bar.x} ${bar.y}
        `
}